export function sum(...sums) {
  return sums.reduce((accSum, sum) => {
    return sum.reduce((acc, money) => {
      const i = acc.findIndex(({currency}) => money.currency === currency)
      if (i !== -1) {
        acc[i].value += money.value
      } else {
        acc.push({...money})
      }
      return acc
    }, accSum)
  }, [])
}

export function subtract(a, b) {
  return sum(a, invert(b))
}

export function isZero(sum) {
  return !sum.find(({ value }) => value !== 0)
}

export function isEqual(a, b) {
  if ((a || b) && (!a || !b)) { return false }
  if (a === b) { return true }
  return isZero(subtract(a, b))
}

const invertMoney = ({value, currency}) => ({currency, value: -value})

export function invert(sum) {
  return sum.map(invertMoney)
}



// WEBPACK FOOTER //
// ./app/webpack/shared/utils/MoneySum.js